import { createTypes } from 'redux-recompose';

export const actionsCounterMaterial = createTypes(['APPLY_COUNTER_MATERIAL'], '@@PML');

const actionCreators = {
    APPLY_COUNTER_MATERIAL: (response) => ({ type: actionsCounterMaterial.APPLY_COUNTER_MATERIAL, notification: response }),
};

export default actionCreators;